// import api from '../config/api'; // Disabled to avoid Google API billing issues

// const GOOGLE_FLIGHTS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY; // Disabled to avoid Google API billing issues

class GoogleFlightsService {
  async searchFlights(origin, destination, departureDate, returnDate, passengers = 1) {
    try {
      console.log('🔍 Google Flights: Searching flights...', { origin, destination, departureDate, returnDate, passengers });
      
      // Use Google Places API to get flight search results - DISABLED to avoid billing issues
      // const response = await api.get('/api/places/search', {
      //   params: {
      //     query: `flights from ${origin} to ${destination}`,
      //     type: 'airport',
      //     fields: 'name,formatted_address,geometry,place_id'
      //   }
      // });

      // For now, return sample flight data since Google Flights API is not publicly available
      // In a real implementation, you would use Google's QPX Express API or similar
      const sampleFlights = this.generateSampleFlights(origin, destination, departureDate, returnDate, passengers);
      
      console.log(`✅ Google Flights: Found ${sampleFlights.length} flight options`);
      return sampleFlights;
    } catch (error) {
      console.warn('Google Flights search failed:', error);
      return [];
    }
  }

  generateSampleFlights(origin, destination, departureDate, returnDate, passengers) {
    const airlines = ['American Airlines', 'Delta', 'United', 'Air France', 'Lufthansa', 'British Airways'];
    const prices = [680, 720, 750, 780, 820, 850, 880, 920];
    
    return Array.from({ length: 6 }, (_, index) => ({
      id: `google_${origin}_${destination}_${index}`,
      airline: airlines[index % airlines.length],
      origin: origin,
      destination: destination,
      departure_time: departureDate,
      arrival_time: returnDate,
      price: `$${prices[index % prices.length]}`,
      booking_url: `https://www.google.com/flights?hl=en#flt=${origin}.${destination}.${departureDate}*${destination}.${origin}.${returnDate};c:USD;e:1;sd:1;t:f;tt:o`,
      source: 'google_flights',
      duration: `${Math.floor(Math.random() * 4) + 8}h ${Math.floor(Math.random() * 60)}m`,
      stops: index % 3 === 0 ? 'Non-stop' : `${index % 2} stop${index % 2 === 1 ? '' : 's'}`
    }));
  }

  async getFlightPrices(origin, destination, departureDate, returnDate, passengers = 1) {
    try {
      // This would integrate with Google's pricing API
      // For now, return sample pricing data
      return this.generateSampleFlights(origin, destination, departureDate, returnDate, passengers);
    } catch (error) {
      console.warn('Google Flights pricing failed:', error);
      return [];
    }
  }
}

const googleFlightsService = new GoogleFlightsService();
export default googleFlightsService;
